import { Building2, Hospital, Globe, Briefcase, Landmark, Shield } from 'lucide-react';

// Tashkilot ikonkalari (organization.icon_name -> Lucide ikonka)
export const ORG_ICON_MAP = { Building2, Hospital, Globe, Briefcase, Landmark, Shield };

// Tashkilot rangi (organization.color) -> fon/matn/border klasslari
export const ORG_COLOR_STYLES = {
    emerald: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20',
    blue: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20',
    purple: 'bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-500/20',
    amber: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20',
    rose: 'bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-500/20',
    indigo: 'bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 border-indigo-500/20',
};

export const ORG_DOT_COLORS = {
    emerald: 'bg-emerald-500',
    blue: 'bg-blue-500',
    purple: 'bg-purple-500',
    amber: 'bg-amber-500',
    rose: 'bg-rose-500',
    indigo: 'bg-indigo-500',
};

export const getOrgIcon = (org) => (org?.icon_name && ORG_ICON_MAP[org.icon_name]) || Building2;
export const getOrgColorClass = (org) => ORG_COLOR_STYLES[org?.color] || ORG_COLOR_STYLES.emerald;
